import axios from "axios";
import getAuthData from '@/utils/getAuthData';


export const sendPendingInvites = async ({ contractorIds }: { contractorIds: string[] }) => {
  const { headers } = await getAuthData();

  const uri = `${process.env.VUE_APP_LAMBDA}/send-pending-invite-contractors`;
  try {
    const response = await axios.post(
      uri,
      { contractorIds },
      { headers }
    );
   
    return response.data; 
  } catch (error) {
    console.error("Failed to send pending invites", error);
    throw error; // Rethrow or handle as needed
  }
};
